module.exports = __webpack_public_path__ + "img/business2.c19237d2.png";